import { BaseError } from './BaseError';
import { InternalErrorCode } from '../../errors/internalErrorCodes';

type FYMAPIErrorProps = {
  statusCode: number;
  message?: string;
  internalCode?: InternalErrorCode;
};

export class FYMAPIError extends BaseError {
  public internalCode: InternalErrorCode | undefined;

  /**
   * The HTTP status the server answered with.
   *
   * Kept rather than only folded into `isOperational`: a caller sometimes has
   * to tell one refusal from another — a 409 on a claim means the row is
   * already where the artist wants it, which is news rather than a failure.
   */
  public statusCode: number;

  constructor({ message, statusCode, internalCode }: FYMAPIErrorProps) {
    super({ message, isOperational: statusCode < 500 });
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    Object.setPrototypeOf(this, FYMAPIError.prototype);
    this.name = 'FYMAPIError'; // A literal name survives minification.
    this.internalCode = internalCode;
    this.statusCode = statusCode;
  }
}
